import DB from "./DB.js";
import TranslatedObject from "./TranslatedObject"
export default class DataModel{
    constructor(json) {
        /**
         *  Le json
         */
        this.json=json;
        /**
         * @type {string}
         */
        this.id=json.id;
        /**
         * @type {string}
         */
        this.type=json.type;
        /**
         * Titre de la page
         * @type {TranslatedObject}
         */
        this.title=new TranslatedObject(json.title);

        DB.inst.addModel(this);

    }
}